export default "__VITE_ASSET__BhvjDoJy__"